/** The `userSources.error` processing writes when the content is too large to store. */
export const TOO_LARGE_ERROR = 'Content too large';
